import { api } from "../api"

export interface DbNotification {
  id: string
  user_id: string
  type: string
  title: string
  message: string | null
  link: string | null
  read: boolean
  read_at: string | null
  created_at: string
}

export interface EventInvitation {
  id: string
  token: string
  event_id: string
  event: {
    id: string
    slug: string
    title: string
    displayPictureUrl: string | null
    coverUrl: string | null
  }
  invited_by: {
    id: string
    username: string | null
    avatarUrl: string | null
  }
  created_at: string
  expires_at: string | null
}

export interface NotificationsResponse {
  eventInvitations: EventInvitation[]
  dbNotifications: DbNotification[]
  count: number
}

export async function getNotifications(): Promise<NotificationsResponse> {
  return api.get<NotificationsResponse>("/notifications/get-all-user-notifications")
}

export async function markNotificationRead(notificationId: string): Promise<DbNotification> {
  return api.post<DbNotification>("/notifications/mark-notification-read", {
    notificationId,
  })
}

export async function markAllNotificationsRead(): Promise<{ updated: number; notifications: DbNotification[] }> {
  return api.post<{ updated: number; notifications: DbNotification[] }>("/notifications/mark-all-read")
}

export async function deleteNotification(notificationId: string): Promise<DbNotification> {
  return api.post<DbNotification>("/notifications/delete-notification", {
    notificationId,
  })
}

export async function getSseToken(): Promise<{ token: string; expiresAt: string }> {
  return api.post<{ token: string; expiresAt: string }>("/notifications/sse/token", {})
}

export async function getVapidPublicKey(): Promise<string | null> {
  try {
    const data = await api.get<{ vapidPublicKey?: string }>("/notifications/push/vapid-public")
    return data.vapidPublicKey ?? null
  } catch {
    return null
  }
}

export async function subscribePushSubscription(payload: {
  endpoint: string
  keys: { p256dh: string; auth: string }
}): Promise<boolean> {
  try {
    await api.post("/notifications/push/subscribe", payload)
    return true
  } catch {
    return false
  }
}

export async function unsubscribePushSubscription(endpoint: string): Promise<boolean> {
  try {
    await api.post("/notifications/push/unsubscribe", { endpoint })
    return true
  } catch {
    return false
  }
}
